import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import { TenantMultiSelect } from "../../shared/TenantMultiSelect";

export const TenantMulti: FC<InputProps<string[]>> = props => <TenantMultiSelect {...props} />;
